export default __webpack_public_path__ + "static/media/ro.b931ef68.svg";